import Choices from 'choices.js';
// import Pikaday from 'pikaday';
import './validation';
import './form-labels';
// import './optional-fields';
// import './inputfile';


// var picker = new Pikaday({
//   field: document.getElementById('date'),
//   theme: 'starwind',
//   minDate: new Date()
// });

if (document.querySelector('.js-choice')) {
  Array.from(document.querySelectorAll('.js-choice')).forEach(
    element => new Choices(element, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false
    }));
}



//////////////////
// WEBPACK FOOTER
// ./src/js/forms/index.js
// module id = 5
// module chunks = 0